import "./InputSearchIcon.scss";

export const InputSearchIcon = () => {
  return (
    <div className="c-input-search-icon__container">
      <div className="c-input-search-icon icon-magnify" aria-label="Search" />
    </div>
  );
};
